"use strict";
/**
 *
 * queryParams
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const query_string_1 = require("query-string");
const pickBy_1 = __importDefault(require("lodash/pickBy"));
const cloneDeepWith_1 = __importDefault(require("lodash/cloneDeepWith"));
const date_1 = require("./date");
const ARRAY_FORMAT = 'bracket';
function isNaN(num) {
    // only NaN is not equal to itself
    return num !== num;
}
function strictUriEncode(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, (x) => `%${x
        .charCodeAt(0)
        .toString(16)
        .toUpperCase()}`);
}
exports.strictUriEncode = strictUriEncode;
/** Stringify function which omits `undefined`, `null`, and empty arrays. */
function stringify(value, props = {}) {
    const { prependQuestionMark } = props;
    const str = query_string_1.stringify(pickBy_1.default(cloneDeepWith_1.default(value, (val) => {
        // persist empty arrays
        if (Array.isArray(val) && val.length === 0) {
            return [null];
        }
        // convert valid dates to iso strings
        if (val instanceof Date) {
            if (isNaN(val.getDate())) {
                return null;
            }
            return val.toISOString();
        }
    }), (part) => part != null), { arrayFormat: ARRAY_FORMAT });
    if (prependQuestionMark && str.length > 0) {
        return '?' + str;
    }
    return str;
}
exports.stringify = stringify;
/** Parses the URL query string following the `QueryModel` definitions. */
function parseQueryParams(queryString, model) {
    const parsedQuery = query_string_1.parse(queryString, {
        arrayFormat: ARRAY_FORMAT,
        parseBooleans: true,
        parseNumbers: true,
    });
    const parsedValues = Object.keys(model).reduce((accumulator, key) => {
        const { type, validate, defaultValue } = model[key];
        const parsedAndValidatedQueryValue = (() => {
            let parsedQueryValue = parsedQuery[key];
            if (type === 'string' &&
                (typeof parsedQueryValue === 'number' || typeof parsedQueryValue === 'boolean')) {
                parsedQueryValue = parsedQueryValue.toString();
            }
            else if (type === 'array' &&
                parsedQueryValue &&
                parsedQueryValue.length === 1 &&
                parsedQueryValue[0] == null) {
                parsedQueryValue = [];
            }
            else if (type === 'date' && parsedQueryValue) {
                parsedQueryValue = date_1.stripTime(date_1.parseISOToDate(parsedQueryValue));
                if (isNaN(parsedQueryValue.getTime())) {
                    return undefined;
                }
            }
            if (validate && parsedQueryValue !== undefined && !validate(parsedQueryValue)) {
                return undefined;
            }
            return parsedQueryValue;
        })();
        return deepFreeze(Object.assign(Object.assign({}, accumulator), { [key]: parsedAndValidatedQueryValue === undefined
                ? typeof defaultValue === 'function'
                    ? defaultValue()
                    : defaultValue
                : parsedAndValidatedQueryValue }));
    }, {});
    return parsedValues;
}
exports.parseQueryParams = parseQueryParams;
function deepFreeze(object) {
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach((name) => {
        const property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) {
            deepFreeze(property);
        }
    });
    return object;
}
